import axios from "@axios";
import * as ep from "./endpoints";
export default class TransactionsService {
  static createQrFile(payload) {
    return axios.post(ep.QR_FILE_CREATE, payload, {
      responseType: "blob",
    });
  }
  static createTransactions(payload) {
    return axios.post(ep.TRANACTIONS_CREATE, payload);
  }
  static fetchOrgInformation() {
    return axios.get(ep.ORG_INFORMATION);
  }
  static fetchJobTitles() {
    return axios.get(ep.JOB_TITLES);
  }
  static fetchTransactionType() {
    return axios.get(ep.TRANSACTION_TYPES);
  }
  static updateTransactions(payload) {
    return axios.post(ep.TRANACTION_BY_ID(payload.id), payload.req);
  }
  static fetchTransactioById(id) {
    return axios.get(ep.TRANACTION_BY_ID(id)).then((res) => res.data);
  }
  static fetchTransactionDesc(id) {
    return axios.get(ep.TRANACTION_Desc_BY_ID(id)).then((res) => res.data);
  }
  static checkConsecutiveSubmission(id) {
    return axios.get(ep.CONSECUTIVESUBMISSION_BY_ID(id)).then((res) => res.data);
  }
}
